import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
	BURGER_TOGGLE: '[data-fragment="MenuComponent.burgerToggle"]',
	NAVIGATION: '[data-fragment="MenuComponent.navigation"]',
	BACKDROP: '[data-fragment="MenuComponent.backdrop"]',
	USER_PROFILE: '[data-fragment="MenuComponent.userProfile"]',
	MAIN_MENU: '[data-fragment="MenuComponent.mainMenu"]',
	SECONDARY_MENU: '[data-fragment="MenuComponent.secondaryMenu"]',
	USER_MENU: '[data-fragment="MenuComponent.userMenu"]',
	USER_MENU_LIST: '[data-fragment="MenuComponent.userMenuList"]',
	SVG_ICON_WRAP: '[data-fragment="MenuComponent.svgIconWrap"]',

	HEADER_MENU: '[data-fragment="MenuComponent.headerMenu"]',
	HEADER_INFO: '[data-fragment="MenuComponent.headerInfo"]',
	HEADER_CONTACT: '[data-fragment="MenuComponent.headerContact"]',
	// HEADER_FULLTEXT: '[data-fragment="MenuComponent.headerFulltext"]',
	// HEADER_MESSAGES: '[data-fragment="MenuComponent.headerMessages"]',
	// HEADER_SETTINGS: '[data-fragment="MenuComponent.headerSettings"]',
};

class MenuComponent extends WebComponent {

	constructor(props) {
		super(props);
		const {
			expandedNavigation = false,
			expandedUserProfile = false,
			docWidth = this.getActualWidth(),
		} = props;
		this.state = {
			expandedNavigation,
			expandedUserProfile,
			docWidth,
		};
	}

	didMount() {
		const {
			backdropOpenNavigationClass,
			backdropOpenUserProfileClass,
			fulltextActiveClass,
		} = this.props;

		this.backdropOpenNavigationClass = backdropOpenNavigationClass;
		this.backdropOpenUserProfileClass = backdropOpenUserProfileClass;
		this.fulltextActiveClass = fulltextActiveClass;

		this.on('click', fragments.BURGER_TOGGLE, this.handleClickBurgerToggle);
		this.on('click', fragments.USER_PROFILE, this.handleClickUserProfileToggle);
		this.on('click', fragments.BACKDROP, this.handleHideBackdrop);
		this.burgerToggleElement = this.element.querySelector(fragments.BURGER_TOGGLE);
		this.navigationElement = this.element.querySelector(fragments.NAVIGATION);
		this.backdropElement = this.element.querySelector(fragments.BACKDROP);
		this.userProfileElement = this.element.querySelector(fragments.USER_PROFILE);
		this.mainMenuElement = this.element.querySelector(fragments.MAIN_MENU);
		this.secondaryMenuElement = this.element.querySelector(fragments.SECONDARY_MENU);
		this.userMenuElement = this.element.querySelector(fragments.USER_MENU);
		this.userMenuListElement = this.element.querySelector(fragments.USER_MENU_LIST);
		this.svgIconWrapElement = this.element.querySelector(fragments.SVG_ICON_WRAP);
		this.headerMenuElement = this.element.querySelector(fragments.HEADER_MENU);
		this.headerInfoElement = this.element.querySelector(fragments.HEADER_INFO);
		// this.headerFulltextElement = this.element.querySelector(fragments.HEADER_FULLTEXT);
		// this.headerMessagesElement = this.element.querySelector(fragments.HEADER_MESSAGES);
		// this.headerSettingsElement = this.element.querySelector(fragments.HEADER_SETTINGS);
		this.headerContactElement = this.element.querySelector(fragments.HEADER_CONTACT);
		window.addEventListener("load", this.initMenu);
		window.addEventListener("resize", this.initMenu);

		this.element.classList.add('header__menu--load');
		// const _self = this;
		// document.onreadystatechange = function(){
		// 	if(document.readyState === 'complete'){
		// }
		// }
	}

	initMenu = (e) => {
		var actualWidth = this.getActualWidth();
		if(this.state.docWidth !== actualWidth){
			this.setState({
				docWidth: actualWidth
			});
			this.handleHideBackdrop(e);
		}

		// Header menu RWD
		if (this.mainMenuElement) {
			if (window.innerWidth < 1400) {
				if(this.navigationElement){
					this.navigationElement.appendChild(this.mainMenuElement);
					this.navigationElement.insertBefore(this.mainMenuElement, this.secondaryMenuElement);
				}
			} else {
				this.element.insertBefore(this.mainMenuElement, this.headerMenuElement);
			}
		}


		// Header info RWD
		if (this.headerInfoElement) {
			if (window.innerWidth < 650) {
				if(this.userMenuListElement){
					this.userMenuListElement.appendChild(this.headerInfoElement);
				}
				if(this.userMenuElement) {
					this.userMenuElement.insertBefore(this.headerInfoElement, this.userMenuListElement);
				}
			} else {
				if(this.headerMenuElement) {
					this.headerMenuElement.insertBefore(this.headerInfoElement, this.svgIconWrapElement);
				}
				// this.headerInfoElement.appendChild(this.navigationElement);
			}
		}

		// Header phone RWD

		if (this.headerContactElement) {
			if (window.innerWidth >= 320) {
				this.headerContactElement.style.display = 'inline-flex';
				// this.element.insertBefore(this.headerContactElement, this.navigationElement.nextSibling);
			} else {
				this.headerContactElement.style.display = 'none';
				// this.navigationElement.appendChild(this.headerContactElement);
			}
		}

		// Header SVG icons RWD
		// if (window.innerWidth < 768) {
		// 	//fulltext
		// 	if (this.headerFulltextElement) {
		// 		this.navigationElement.insertBefore(this.headerFulltextElement, this.mainMenuElement);
		// 		this.headerFulltextElement.classList.add(this.fulltextActiveClass);
		// 	}
		// 	//messages
		// 	if (this.headerMessagesElement) {
		// 		this.navigationElement.appendChild(this.headerMessagesElement);
		// 	}
		// 	//settings
		// 	if (this.headerSettingsElement) {
		// 		this.navigationElement.appendChild(this.headerSettingsElement);
		// 	}
		//
		// } else {
		// 	//settings
		// 	if (this.headerSettingsElement) {
		// 		this.svgIconWrapElement.appendChild(this.headerSettingsElement);
		// 		this.svgIconWrapElement.insertBefore(this.headerSettingsElement, this.svgIconWrapElement.firstChild);
		// 	}
		// 	//messages
		// 	if (this.headerMessagesElement) {
		// 		this.svgIconWrapElement.appendChild(this.headerMessagesElement);
		// 		this.svgIconWrapElement.insertBefore(this.headerMessagesElement, this.svgIconWrapElement.firstChild);
		// 	}
		// 	//fulltext
		// 	if(this.headerFulltextElement) {
		// 		this.headerFulltextElement.classList.remove(this.fulltextActiveClass);
		// 		this.svgIconWrapElement.appendChild(this.headerFulltextElement);
		// 		this.svgIconWrapElement.insertBefore(this.headerFulltextElement, this.svgIconWrapElement.firstChild);
		// 	}
		// }
	}

	handleClickBurgerToggle = (e) => {
		const {
			expandedNavigation,
		} = this.state;

		this.setState({
			expandedNavigation: !expandedNavigation,
			expandedUserProfile: false,
		});

		if(!expandedNavigation){
			document.documentElement.classList.add(this.backdropOpenNavigationClass);
			document.documentElement.classList.remove(this.backdropOpenUserProfileClass);
		} else {
			document.documentElement.classList.remove(this.backdropOpenNavigationClass);
		}
	}

	handleClickUserProfileToggle = (e) => {
		const {
			expandedUserProfile,
		} = this.state;

		let isInside = false;

		let isClickInside = this.userMenuElement.contains(e.target);
		if (isClickInside) {
			isInside = true;
		}

		if(!isInside) {
			this.setState({
				expandedUserProfile: !expandedUserProfile,
				expandedNavigation: false,
			});

			if(!expandedUserProfile){
				document.documentElement.classList.add(this.backdropOpenUserProfileClass);
				document.documentElement.classList.remove(this.backdropOpenNavigationClass);
			} else {
				document.documentElement.classList.remove(this.backdropOpenUserProfileClass);
			}
		}

	}

	handleHideBackdrop = (e) => {
		e.preventDefault();

		const {
			expandedNavigation,
			expandedUserProfile,
		} = this.state;

		this.setState({
			expandedNavigation: false,
			expandedUserProfile: false,
		});
		document.documentElement.classList.remove(this.backdropOpenUserProfileClass);
		document.documentElement.classList.remove(this.backdropOpenNavigationClass);
		if(this.backdropElement) {
			this.backdropElement.classList.remove('menu-backdrop--opened');
		}
	}

	willUnMount() {
		this.burgerToggleElement = null;
		this.navigationElement = null;
		this.backdropElement = null;
		this.userProfileElement = null;
		this.mainMenuElement = null;
		this.svgIconWrapElement = null;
		this.headerMenuElement = null;
		this.headerInfoElement = null;
		this.headerContactElement = null;
		// this.headerFulltextElement = null;
		// this.headerMessagesElement = null;
		// this.headerSettingsElement = null;
	}

	update(prevProps, prevState, inDocument) {
		const {
			expandedNavigation,
			expandedUserProfile,
		} = this.state;

		if(this.userProfileElement) {
			classNames(this.userProfileElement, {
				'header__user-profile--active': expandedUserProfile,
			});
			this.userProfileElement.setAttribute('aria-expanded', expandedUserProfile);
		}

		if(this.navigationElement) {
			classNames(this.navigationElement, {
				'navigation--expanded': expandedNavigation,
			});
			this.navigationElement.setAttribute('aria-expanded', expandedNavigation);
		}
		//Animace burger menu
		if(this.burgerToggleElement) {
			classNames(this.burgerToggleElement, {
				'menu-burger--close': expandedNavigation,
			});

			classNames(this.burgerToggleElement, {
				'menu-burger--show': !expandedNavigation,
			});
		}

		//Backdrop open/close
		classNames(this.backdropElement, {
			'menu-backdrop--opened': (expandedNavigation || expandedUserProfile),
		});

	}

	getActualWidth = () => {
		return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || document.body.offsetWidth;
	}
}

MenuComponent.defaultProps = {
	backdropOpenNavigationClass: 'menu-backdrop--open-navigation',
	backdropOpenUserProfileClass: 'menu-backdrop--open-user-profile',
	// fulltextActiveClass: 'header__fulltext--active',
};

export default MenuComponent;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Menu/MenuComponent.js